import { call, put, takeLatest } from "redux-saga/effects";
import {
  fetchFestivalRequest,
  fetchFestivalSuccess,
  fetchFestivalFail,
} from "../slices/festivalSlice";

function* fetchFestivalWorker() {
  try {
    const res = yield call(
      fetch,
      `${process.env.REACT_APP_API_URL}/v1/festivals/status/active`,
    );

    const result = yield call([res, "json"]);

    if (result?.success) {
      yield put(fetchFestivalSuccess(result.data || []));
    } else {
      yield put(fetchFestivalFail("Failed"));
    }
  } catch (error) {
    yield put(fetchFestivalFail(error.message));
  }
}

export function* watchFestival() {
  yield takeLatest(fetchFestivalRequest.type, fetchFestivalWorker);
}
